import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  Label,
  MessageBar,
  MessageBarType,
  PrimaryButton,
  Spinner
} from "@fluentui/react";

const ContentApiSecretsDialog = ({
  visible,
  secrets,
  copyFeedback,
  copyFeedbackType,
  uploadMessage,
  uploadError,
  uploadingSecrets,
  onCopy,
  onUpload,
  onDismiss
}) => (
  <Dialog
    hidden={!visible}
    onDismiss={onDismiss}
    dialogContentProps={{
      type: DialogType.largeHeader,
      title: "Generated Azure Secrets"
    }}
  >
    <p>Copy these credentials now—they will not be shown again.</p>
    <div className="mb10">
      <Label>Client ID (18 digits)</Label>
      <pre style={{ backgroundColor: "#f3f2f1", padding: "8px" }}>{secrets?.clientId}</pre>
      <DefaultButton text="Copy Client ID" onClick={() => onCopy(secrets?.clientId)} />
    </div>
    <div className="mb10">
      <Label>Client Secret (40 characters)</Label>
      <pre style={{ backgroundColor: "#f3f2f1", padding: "8px" }}>{secrets?.clientSecret}</pre>
      <DefaultButton text="Copy Client Secret" onClick={() => onCopy(secrets?.clientSecret)} />
    </div>
    <div className="mb10">
      <Label>Content API Key (plain, hashed automatically)</Label>
      <pre style={{ backgroundColor: "#f3f2f1", padding: "8px" }}>{secrets?.apiKeyPlain}</pre>
      <DefaultButton text="Copy API Key" onClick={() => onCopy(secrets?.apiKeyPlain)} />
    </div>
    {copyFeedback && (
      <MessageBar messageBarType={copyFeedbackType}>{copyFeedback}</MessageBar>
    )}
    {uploadMessage && (
      <MessageBar messageBarType={MessageBarType.success}>{uploadMessage}</MessageBar>
    )}
    {uploadError && (
      <MessageBar messageBarType={MessageBarType.error}>{uploadError}</MessageBar>
    )}
    <DialogFooter>
      <PrimaryButton
        text={uploadingSecrets ? "Uploading..." : "Upload to Azure Key Vault"}
        disabled={uploadingSecrets || !secrets}
        onClick={onUpload}
      />
      {uploadingSecrets && <Spinner className="mt10" label="Uploading..." />}
      <DefaultButton text="Close" onClick={onDismiss} />
    </DialogFooter>
  </Dialog>
);

export default ContentApiSecretsDialog;
